export default __webpack_public_path__ + "static/media/267.2e645190.png";